import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
// import axios from 'axios';
import { userObj } from "../../../../helper/protectedRoutes";
import axios from "../../../../api/axios";

const initialState = {
    placeIddata:[],
    isGettingPlaceId:false,
    status:null,
}

const token = userObj?.token

export const getPlaceId = createAsyncThunk(
    'customer/getPlaceId',
    async (placeid, {rejectWithValue}) => {
        
        try{
            const response = await axios.get(`Order/addrDetail?placeId=${placeid}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
            )
            return response?.data
        } catch (err) {
            console.log(err.response)
            return rejectWithValue(err.response.data.title)
        }
        
    }
)


const getPlaceIdSlice = createSlice({
    name: 'getPlaceId',
    initialState,
    reducers: {},
    extraReducers:{
        [getPlaceId.pending]: (state, action) => {
            state.status='pending';
            state.isGettingPlaceId=true;
        },
        [getPlaceId.fulfilled]: (state, action) => {
            state.status='success';
            state.isGettingPlaceId=false;
            state.placeIddata = action.payload;
            // localStorage.setItem('user', JSON.stringify(action.payload))
        },
    
        [getPlaceId.rejected]: (state, action) => {
            state.status='failed';
            state.isGettingPlaceId=false;
        }
    }
})

export default getPlaceIdSlice.reducer;